export const INVESTOR_TYPE = {
	institutional: 'institutional',
	nonProfessional: 'non-professional'
};

export const PRIVATE_INVESTOR = {
	label: 'privateInvestorOrRetail',
	value: 'non-professional'
};

export const INSTITUTIONAL_INVESTOR = {
	label: 'institutionalInvestor',
	value: 'institutional'
};

export const LIST_INVESTOR = [PRIVATE_INVESTOR, INSTITUTIONAL_INVESTOR];

export const INVESTOR_RIGHTS_TYPE = {
	slfLux: 'slf-lux',
	slifLux: 'slif-lux',
	privado: 'privado'
};
